module.exports = require('./dist/vue-luck-draw.common.js')



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-luck-draw/index.js
// module id = jZDa
// module chunks = 87